import { useEffect } from "react";

const DEFAULT_TITLE = "Mwezzy Footwear | STEP DIFFERENT.";
const DEFAULT_DESC = "Mwezzy Footwear is a South African online sneaker and footwear store with nationwide courier delivery.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function Seo({ title, description, image, type = "website", jsonLd }) {
  useEffect(() => {
    const t = title ? `${title} | Mwezzy Footwear` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const img = image || `${window.location.origin}/logo-512.webp`;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:site_name", "Mwezzy Footwear");
    setMeta("name", "twitter:card", "summary_large_image");
    let script = document.getElementById("jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) script.remove();
  }, [title, description, image, type, jsonLd]);
  return null;
}
